import {
  rehydrateCropPictureFilesInPersistedClient,
  stripCropPictureFilesFromPersistedClient,
} from '@lidea/shared/data-access/analysis';
import {
  PersistedClient,
  Persister,
} from '@tanstack/react-query-persist-client';
import { del, get, set } from 'idb-keyval';

/**
 * Creates an Indexed DB persister
 * @see https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */
export function createIDBPersister(idbValidKey: IDBValidKey = 'tanstackQuery') {
  return {
    persistClient: async (client: PersistedClient) => {
      await set(
        idbValidKey,
        stripCropPictureFilesFromPersistedClient(client)
      );
    },
    restoreClient: async () => {
      const client = await get<PersistedClient>(idbValidKey);
      if (!client) {
        return undefined;
      }
      return rehydrateCropPictureFilesInPersistedClient(client);
    },
    removeClient: async () => {
      await del(idbValidKey);
    },
  } as Persister;
}
